import { useState } from "react";
import { Customer } from "../../api/member/register/_id@string/_datetime_hash@string";
import STUtils from "../../assets/styles/utility.module.scss";
import { routes } from "../../router/Router";
import { getSubdomain } from "../../utils/getSubdomain";
import LoginBackground from "../organisms/LoginBackground";
import MemberEntryApplyCard from "../organisms/MemberEntryApplyCard";
import MemberEntryForm from "../organisms/MemberEntryForm";
import PWAInstallationModal from "../organisms/PWAInstallationModal";
import BaseHead from "../templates/BaseHead";

const MemberEntryNomal = (): JSX.Element => {
  const subdomain = getSubdomain(window.location.hostname);
  const [customer] = useState<Customer>({});
  const [isApplied, setIsApplied] = useState(false);
  const [, setSigninData] = useState({ email: null, Password: null });
  return (
    <BaseHead
      title={routes.memberEntry.title}
      login={false}
      subdomain={subdomain}
      hasBackground={true}
    >
      <LoginBackground />
      <section className={STUtils.container_large}>
        {isApplied ? (
          <MemberEntryApplyCard />
        ) : (
          <MemberEntryForm
            customer={customer}
            setIsApplied={setIsApplied}
            setSigninData={setSigninData}
          />
        )}
        <PWAInstallationModal closePopup={() =>{}} />
      </section>
    </BaseHead>
  );
};

export default MemberEntryNomal;
